import { add } from "date-fns";

export const OptionsFormater = (array: any[]) => {
  if (array.length > 0) {
    const optionsArray = array.map((it) => {
      return {
        label: it.title,
        value: it.id,
      };
    });

    return optionsArray;
  }

  return [];
};

export const stripHtmlTagsAdvanced = (html: string): string => {
  try {
    const elementoTemporario = document.createElement('div');
    elementoTemporario.innerHTML = html;

    return elementoTemporario.textContent || elementoTemporario.innerText || '';
  } catch (e: any) {
    return '';
  }
};

export function getTimeAgo(date: Date): string {
  const now = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

  const second = diff;
  const minute = Math.floor(diff / 60);
  const hour = Math.floor(diff / 3600);
  const day = Math.floor(diff / 86400);
  const week = Math.floor(diff / 604800);
  const month = Math.floor(diff / 2592000);
  const year = Math.floor(diff / 31536000);

  if (year > 0) return year === 1 ? 'Há 1 ano' : `Há ${year} anos`;
  if (month > 0) return month === 1 ? 'Há 1 mês' : `Há ${month} meses`;
  if (week > 0) return week === 1 ? 'Há 1 semana' : `Há ${week} semanas`;
  if (day > 0) return day === 1 ? 'Há 1 dia' : `Há ${day} dias`;
  if (hour > 0) return hour === 1 ? 'Há 1 hora' : `Há ${hour} horas`;
  if (minute > 0) return minute === 1 ? 'Há 1 minuto' : `Há ${minute} minutos`;
  if (second >= 0) return 'Agora mesmo';

  return '';
}

/**
 * Monta o texto do tooltip com a data em que o conteúdo foi visto pela primeira
 * vez. Retorna `null` quando não há data válida (nunca visto).
 */
export function getFirstViewedLabel(
  firstViewedAt?: string | null
): string | null {
  if (!firstViewedAt) return null;

  const date = new Date(firstViewedAt);
  if (isNaN(date.getTime())) return null;

  return `Visto pela primeira vez em ${date.toLocaleDateString('pt-BR')}`;
}

export function getDayName(day: string) {
  console.log('day', day);
  const dayNumber = add(new Date(day), { hours: 3 }).getDay();
  console.log('dayNumber', dayNumber);
  const days = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];
  
  console.log('days', days[dayNumber]);
  return days[dayNumber];
}